module.exports = __webpack_public_path__ + "static/media/project-image-2.6f790fd2.jpg";